import React, { useEffect, useRef } from "react";
import * as d3 from "d3";

const D3DensityMap = ({ data, width, height }) => {
  const svgRef = useRef();
  const margin = 20

  useEffect(() => {
    if (!data || !width || !height) return;

    // console.log(data);

    // Clear previous SVG content
    d3.select(svgRef.current).selectAll("*").remove();

    // Create SVG container
    const svg = d3
      .select(svgRef.current)
      .attr("width", width)
      .attr("height", height)
      .attr("viewBox", [0, 0, width, height])
      .attr("style", "max-width: 100%; height: auto;");

    // Create scales for x and y axes
    const xScale = d3
      .scaleLinear()
      .domain([-20, 20])
      .range([margin, width-margin]);

    const yScale = d3
      .scaleLinear()
      .domain([0, 50])
      .range([height-margin, margin]);

    // Create a kernel density estimator
    const density = d3
      .contourDensity()
      .x((d) => xScale(d.x))
      .y((d) => yScale(d.y))
      .size([width, height])
      .bandwidth(10) // Adjust bandwidth as needed
      .thresholds(16);

    // Compute density contours
    const contours = density(data);

    // Use the schemeRdBu color scale and reverse it
    // console.log(
    //   d3.max(contours, (d) => d.value),
    //   d3.min(contours, (d) => d.value)
    // );
    const colorScale = d3
      .scaleQuantile()
      .domain([
        d3.max(contours, (d) => d.value),
        d3.min(contours, (d) => d.value),
      ])
      .range([
        "#6889c2",
        "#9bb0d6",
        "#cdd8eb",
        "#ffffff",
        "#f5c8ca",
        "#ec9094",
        "#e2585e",
        "#d82129",
      ]);
    // Draw density contours
    svg
      .append("g")
      .attr("stroke", "none")
      .selectAll()
      .data(contours)
      .join("path")
      // .attr("stroke-width", (d, i) => (i % 5 ? 0.25 : 1))
      .attr("d", d3.geoPath())
      .attr("fill", (d) => colorScale(d.value));

    const x = d3
      .scaleLinear()
      .domain([-20, 20])
      .range([0, width])
      .nice()
      .rangeRound([0, width ]);

    const y = d3
      .scaleLinear()
      .domain([0, 50])
      .nice()
      .rangeRound([height, 0]);

    // svg
    //   .append("g")
    //   .attr("transform", `translate(0,${height-70})`)
    //   .call(d3.axisBottom(x).tickSizeOuter(0))
    //   .call((g) => g.select(".domain").remove())
    //   .call((g) =>
    //     g
    //       .select(".tick:last-of-type text")
    //       .clone()
    //       .attr("y", -3)
    //       .attr("dy", null)
    //       .attr("font-weight", "bold")
    //       .text("Idle (min.)")
    //   );

    // svg
    //   .append("g")
    //   .attr("transform", `translate(${50},0)`)
    //   .call(d3.axisLeft(y).tickSizeOuter(0))
    //   .call((g) => g.select(".domain").remove())
    //   .call((g) =>
    //     g
    //       .select(".tick:last-of-type text")
    //       .clone()
    //       .attr("x", 3)
    //       .attr("text-anchor", "start")
    //       .attr("font-weight", "bold")
    //       .text("Erupting (min.)")
    //   );

    //   svg
    //   .append("g")
    //   .attr("stroke", "white")
    //   .selectAll()
    //   .data(data)
    //   .join("circle")
    //   .attr("cx", (d) => xScale(d.x))
    //   .attr("cy", (d) => yScale(d.y))
    //   .attr("r", 2);

    svg
      .append("polygon")
      .attr(
        "points",
        [
          [10, 18],
          [10, 42],
          [-10, 42],
          [-10, 18],
        ]
          .map((e) => `${xScale(e[0])},${yScale(e[1])}`)
          .join(" ")
      )
      .attr("stroke", "black")
      .attr("stroke-width", 2)
      .attr("fill", "none");
    
    svg
      .append("polygon")
      .attr(
        "points",
        [
          [10, 0],
          [8.5, 2],
          [0, 4],
          [-8.5, 2],
          [-10, 0],
        ]
          .map((e) => `${xScale(e[0])},${yScale(e[1])}`)
          .join(" ")
      )
      .attr("stroke", "black")
      .attr("stroke-width", 2)
      .attr("fill", "none");
  }, [data, width, height]);

  return <svg ref={svgRef} />;
};

export default D3DensityMap